// Third-party imports
import $ from 'jquery';

// Local imports
import { buttonStateHandler } from './button_handler.js';
import { getCurrentlySelectedVariantQuantity } from './cart.js';
import {
    injectVariantMaxQuantityData,
    quantityHandler,
    resetQuantityCounter,
} from './quantity_handler.js';
import * as currency from '../../util/currency.js';

// Called when variants are changed
export function changeHandler(args, index) {
    changePriceStyling(args.variantsArray, index);
    // resetQuantityCounter();
    quantityHandler(args.variantsArray[index]);
    // Update the properties[gift_id] value to the proper selected variant.sku
    $('[name="properties[gift_id]"]').val(args.variantsArray[index].variantSku);

    // Update the properties[cards] value to the variant selected if it's in cart
    let cards = '';
    let qtyInCartRadio = $('input[type="radio"][name="Options"]:checked');
    let hasProduct = false;

    for (let i = 0; i < args.productsInCartArray.length; i++) {
        let item = args.productsInCartArray[i];
        if (item.variant_id === args.variantsArray[index].variantid) {
            cards = item.properties.cards;
            hasProduct = true;

            //We now are loading the quantity input with the amount in cart, however it's possible that the amount in cart was actually updated via a purchase
            resetQuantityCounter(
                qtyInCartRadio.attr('qty-in-cart') === false ||
                    typeof qtyInCartRadio.attr('qty-in-cart') === 'undefined' ||
                    qtyInCartRadio.attr('qty-in-cart') ===
                        String(args.productsInCartArray[i].quantity)
                    ? args.productsInCartArray[i].quantity
                    : qtyInCartRadio.attr('qty-in-cart')
            );
        }
    }

    if (!hasProduct && !Number.isNaN(qtyInCartRadio.attr('qty-in-cart'))) {
        resetQuantityCounter(qtyInCartRadio.attr('qty-in-cart'));
    }
    $('[name="properties[cards]"]').val(cards);

    injectVariantIDCartButton(
        args.variantsArray[index].variantid,
        args.variantsArray[index].isMerchandise
    );
    if (args.variantsArray[index].isMerchandise) {
        getCurrentlySelectedVariantQuantity(
            args.variantsArray[index].variantid,
            args.productsInCartArray,
            args.variantsArray
        );
    }
    let price = currency.clean(args.variantsArray[index].price);

    // in_cents = false and with_symbol = true
    let display_price = currency.format(price, false, true);
    addTextToTargetElement('.js-currentPrice-hook', display_price);
    buttonStateHandler();
}

export function injectVariantIDCartButton(variantID, isMerchandise) {
    $('.js-variantID-hook').val(variantID);
    if (isMerchandise || isMerchandise === undefined) {
        return;
    }
    //$('.js-quantityIncrementer-counter, .js-quantity-hook').val(1);
}

function changePriceStyling(variantsArray, index) {
    addClassToPriceHook('.price--onSale', 'u-hide');
    addClassToPriceHook('.price', 'price--primary');
    removeClassToPriceHook('.js-price-dollarSign-hook', 'u-hide');
    removeClassToPriceHook('.js-currentPrice-hook', 'u-error');
    removeClassToPriceHook('.price', 'price--secondary');
    itemIsOnSaleHandler(variantsArray, index);
}

function itemIsOnSaleHandler(variantsArray, index) {
    if (variantsArray[index].sale) {
        removeClassToPriceHook('.price--onSale', 'u-hide');

        let price = currency.clean(variantsArray[index].sale);

        // in_cents = false and with_symbol = true
        let display_price = currency.format(price, false, true);

        addTextToTargetElement('.js-beforeSalePrice-hook', display_price);
    }
}

export function itemNotFoundHandler() {
    buttonStateHandler();
    // When item not found, set quantity to 0
    //resetQuantityCounter()
    $('.js-quantityIncrementer-counter').val(0);
    injectVariantMaxQuantityData(0);
    addClassToPriceHook('.price--onSale', 'u-hide');
    addClassToPriceHook('.js-price-dollarSign-hook', 'u-hide');
    addClassToPriceHook('.js-currentPrice-hook', 'u-error');
    let errorMessage = $('.js-errorMessage-hook').text();
    addTextToTargetElement('.js-currentPrice-hook', errorMessage);
}

function addTextToTargetElement(target, text) {
    $('.js-priceUpdaterHook')
        .find(target)
        .text(text);
}

function addClassToPriceHook(target, cssClass) {
    $('.js-priceUpdaterHook')
        .find(target)
        .addClass(cssClass);
}

function removeClassToPriceHook(target, cssClass) {
    $('.js-priceUpdaterHook')
        .find(target)
        .removeClass(cssClass);
}
